/* tslint:disable */
/* eslint-disable */
/**
 * AS3.Portals
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AllowTrackingRequest,
  CandidateMember,
  CandidateProfile,
  ContentViewLog,
  DisableProfilePublishNotifierState,
  EvaluationRead,
  IPortalMember,
  JobSearchData,
  LinkedinLearningAccount,
  MemberTimeRegistrationResult,
  MessageResponse,
  ProfileDataResponse,
  ProfileSectionEnum,
  PublicProfile,
  PublicProfileState,
  PublicProfiles,
  PublishedResponse,
  RapportData,
  StatusOnlyResult,
  StatusResponse,
  SuccessResponse,
  TimeRegistration,
  ToggleProfilePublicState,
  UpdateMemberResponse,
  UpdateProfileResponse,
} from '../models/index';
import {
    AllowTrackingRequestFromJSON,
    AllowTrackingRequestToJSON,
    CandidateMemberFromJSON,
    CandidateMemberToJSON,
    CandidateProfileFromJSON,
    CandidateProfileToJSON,
    ContentViewLogFromJSON,
    ContentViewLogToJSON,
    DisableProfilePublishNotifierStateFromJSON,
    DisableProfilePublishNotifierStateToJSON,
    EvaluationReadFromJSON,
    EvaluationReadToJSON,
    IPortalMemberFromJSON,
    IPortalMemberToJSON,
    JobSearchDataFromJSON,
    JobSearchDataToJSON,
    LinkedinLearningAccountFromJSON,
    LinkedinLearningAccountToJSON,
    MemberTimeRegistrationResultFromJSON,
    MemberTimeRegistrationResultToJSON,
    MessageResponseFromJSON,
    MessageResponseToJSON,
    ProfileDataResponseFromJSON,
    ProfileDataResponseToJSON,
    ProfileSectionEnumFromJSON,
    ProfileSectionEnumToJSON,
    PublicProfileFromJSON,
    PublicProfileToJSON,
    PublicProfileStateFromJSON,
    PublicProfileStateToJSON,
    PublicProfilesFromJSON,
    PublicProfilesToJSON,
    PublishedResponseFromJSON,
    PublishedResponseToJSON,
    RapportDataFromJSON,
    RapportDataToJSON,
    StatusOnlyResultFromJSON,
    StatusOnlyResultToJSON,
    StatusResponseFromJSON,
    StatusResponseToJSON,
    SuccessResponseFromJSON,
    SuccessResponseToJSON,
    TimeRegistrationFromJSON,
    TimeRegistrationToJSON,
    ToggleProfilePublicStateFromJSON,
    ToggleProfilePublicStateToJSON,
    UpdateMemberResponseFromJSON,
    UpdateMemberResponseToJSON,
    UpdateProfileResponseFromJSON,
    UpdateProfileResponseToJSON,
} from '../models/index';

export interface DisableJobProfilePublishNotifierRequest {
    disableProfilePublishNotifierState?: DisableProfilePublishNotifierState;
}

export interface GetCalendarIcsRequest {
    eventId?: string;
}

export interface GetCandidateJobProfileStateRequest {
    id?: string;
}

export interface GetCandidateNetworkProfileStateRequest {
    id?: string;
}

export interface GetCandidateProfileImageRequest {
    candidateId?: string;
    rnd?: string;
}

export interface GetCandidatePublicJobProfileRequest {
    id?: string;
}

export interface GetCandidatePublicNetworkProfileRequest {
    id?: string;
}

export interface GetCandidatePublicProfilesRequest {
    userId?: string;
}

export interface GetIcsRequest {
    eventId?: string;
}

export interface GetProfileImageRequest {
    rnd?: string;
}

export interface GetTimeRegistrationsRequest {
    timeZone?: string;
}

export interface SaveContentViewLogRequest {
    contentViewLog?: ContentViewLog;
}

export interface SaveTimeRegistrationRequest {
    timeRegistration?: TimeRegistration;
}

export interface SelectProgrammeRequest {
    programmeId?: string;
}

export interface ToggleJobProfilePublishedStateRequest {
    toggleProfilePublicState?: ToggleProfilePublicState;
}

export interface ToggleNetworkProfilePublishedStateRequest {
    toggleProfilePublicState?: ToggleProfilePublicState;
}

export interface UpdateAllowTrackingRequest {
    allowTrackingRequest?: AllowTrackingRequest;
}

export interface UpdateJobSearchDataRequest {
    jobSearchData?: JobSearchData;
}

export interface UpdateLinkedinLearningAccountRequest {
    linkedinLearningAccount?: LinkedinLearningAccount;
}

export interface UpdateMemberRequest {
    candidateMember?: CandidateMember;
}

export interface UpdateProfileRequest {
    onlyPersonalData?: boolean;
    profileSection?: ProfileSectionEnum;
    candidateProfile?: CandidateProfile;
}

/**
 * 
 */
export class MemberApi extends runtime.BaseAPI {

    /**
     */
    async deleteJobSearchDataRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/MemberApi/DeleteJobSearchData`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteJobSearchData(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteJobSearchDataRaw(initOverrides);
    }

    /**
     */
    async deleteProfileImageRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/MemberApi/DeleteProfileImage`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async deleteProfileImage(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.deleteProfileImageRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async disableJobProfilePublishNotifierRaw(requestParameters: DisableJobProfilePublishNotifierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/umbraco/api/MemberApi/DisableJobProfilePublishNotifier`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DisableProfilePublishNotifierStateToJSON(requestParameters.disableProfilePublishNotifierState),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async disableJobProfilePublishNotifier(requestParameters: DisableJobProfilePublishNotifierRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.disableJobProfilePublishNotifierRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getCalendarIcsRaw(requestParameters: GetCalendarIcsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        if (requestParameters.eventId !== undefined) {
            queryParameters['eventId'] = requestParameters.eventId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/MemberApi/GetCalendarIcs`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async getCalendarIcs(requestParameters: GetCalendarIcsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getCalendarIcsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getCandidateEvaluationsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<EvaluationRead>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/MemberApi/GetCandidateEvaluations`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(EvaluationReadFromJSON));
    }

    /**
     */
    async getCandidateEvaluations(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<EvaluationRead>> {
        const response = await this.getCandidateEvaluationsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getCandidateJobProfileStateRaw(requestParameters: GetCandidateJobProfileStateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PublicProfileState>> {
        const queryParameters: any = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/MemberApi/GetCandidateJobProfileState`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PublicProfileStateFromJSON(jsonValue));
    }

    /**
     */
    async getCandidateJobProfileState(requestParameters: GetCandidateJobProfileStateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PublicProfileState> {
        const response = await this.getCandidateJobProfileStateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getCandidateNetworkProfileStateRaw(requestParameters: GetCandidateNetworkProfileStateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PublicProfileState>> {
        const queryParameters: any = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/MemberApi/GetCandidateNetworkProfileState`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PublicProfileStateFromJSON(jsonValue));
    }

    /**
     */
    async getCandidateNetworkProfileState(requestParameters: GetCandidateNetworkProfileStateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PublicProfileState> {
        const response = await this.getCandidateNetworkProfileStateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getCandidateProfileImageRaw(requestParameters: GetCandidateProfileImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters.candidateId !== undefined) {
            queryParameters['candidateId'] = requestParameters.candidateId;
        }

        if (requestParameters.rnd !== undefined) {
            queryParameters['rnd'] = requestParameters.rnd;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/MemberApi/GetCandidateProfileImage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async getCandidateProfileImage(requestParameters: GetCandidateProfileImageRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getCandidateProfileImageRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getCandidatePublicJobProfileRaw(requestParameters: GetCandidatePublicJobProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PublicProfile>> {
        const queryParameters: any = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/MemberApi/GetCandidatePublicJobProfile`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PublicProfileFromJSON(jsonValue));
    }

    /**
     */
    async getCandidatePublicJobProfile(requestParameters: GetCandidatePublicJobProfileRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PublicProfile> {
        const response = await this.getCandidatePublicJobProfileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getCandidatePublicNetworkProfileRaw(requestParameters: GetCandidatePublicNetworkProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PublicProfile>> {
        const queryParameters: any = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/MemberApi/GetCandidatePublicNetworkProfile`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PublicProfileFromJSON(jsonValue));
    }

    /**
     */
    async getCandidatePublicNetworkProfile(requestParameters: GetCandidatePublicNetworkProfileRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PublicProfile> {
        const response = await this.getCandidatePublicNetworkProfileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getCandidatePublicProfilesRaw(requestParameters: GetCandidatePublicProfilesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PublicProfiles>> {
        const queryParameters: any = {};

        if (requestParameters.userId !== undefined) {
            queryParameters['userId'] = requestParameters.userId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/MemberApi/GetCandidatePublicProfiles`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PublicProfilesFromJSON(jsonValue));
    }

    /**
     */
    async getCandidatePublicProfiles(requestParameters: GetCandidatePublicProfilesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PublicProfiles> {
        const response = await this.getCandidatePublicProfilesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getIcsRaw(requestParameters: GetIcsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters.eventId !== undefined) {
            queryParameters['eventId'] = requestParameters.eventId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/MemberApi/GetIcs`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async getIcs(requestParameters: GetIcsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getIcsRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getMemberRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPortalMember>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/MemberApi/GetMember`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPortalMemberFromJSON(jsonValue));
    }

    /**
     */
    async getMember(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPortalMember> {
        const response = await this.getMemberRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getProfileDataRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProfileDataResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/MemberApi/GetProfileData`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProfileDataResponseFromJSON(jsonValue));
    }

    /**
     */
    async getProfileData(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProfileDataResponse> {
        const response = await this.getProfileDataRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getProfileImageRaw(requestParameters: GetProfileImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters.rnd !== undefined) {
            queryParameters['rnd'] = requestParameters.rnd;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/MemberApi/GetProfileImage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async getProfileImage(requestParameters: GetProfileImageRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getProfileImageRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getProfileImageValidRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/MemberApi/GetProfileImageValid`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async getProfileImageValid(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.getProfileImageValidRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getTimeRegistrationsRaw(requestParameters: GetTimeRegistrationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RapportData>> {
        const queryParameters: any = {};

        if (requestParameters.timeZone !== undefined) {
            queryParameters['timeZone'] = requestParameters.timeZone;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/MemberApi/GetTimeRegistrations`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RapportDataFromJSON(jsonValue));
    }

    /**
     */
    async getTimeRegistrations(requestParameters: GetTimeRegistrationsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RapportData> {
        const response = await this.getTimeRegistrationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async profileExportRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StatusOnlyResult>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/MemberApi/ProfileExport`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StatusOnlyResultFromJSON(jsonValue));
    }

    /**
     */
    async profileExport(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StatusOnlyResult> {
        const response = await this.profileExportRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async remoteLoginRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/MemberApi/RemoteLogin`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async remoteLogin(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.remoteLoginRaw(initOverrides);
    }

    /**
     */
    async resetProfileCacheRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/MemberApi/ResetProfileCache`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     */
    async resetProfileCache(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SuccessResponse> {
        const response = await this.resetProfileCacheRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async saveContentViewLogRaw(requestParameters: SaveContentViewLogRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContentViewLog>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/umbraco/api/MemberApi/SaveContentViewLog`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ContentViewLogToJSON(requestParameters.contentViewLog),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContentViewLogFromJSON(jsonValue));
    }

    /**
     */
    async saveContentViewLog(requestParameters: SaveContentViewLogRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContentViewLog> {
        const response = await this.saveContentViewLogRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async saveTimeRegistrationRaw(requestParameters: SaveTimeRegistrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MemberTimeRegistrationResult>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/umbraco/api/MemberApi/SaveTimeRegistration`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TimeRegistrationToJSON(requestParameters.timeRegistration),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MemberTimeRegistrationResultFromJSON(jsonValue));
    }

    /**
     */
    async saveTimeRegistration(requestParameters: SaveTimeRegistrationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MemberTimeRegistrationResult> {
        const response = await this.saveTimeRegistrationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async selectProgrammeRaw(requestParameters: SelectProgrammeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        if (requestParameters.programmeId !== undefined) {
            queryParameters['programmeId'] = requestParameters.programmeId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/MemberApi/SelectProgramme`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async selectProgramme(requestParameters: SelectProgrammeRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.selectProgrammeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async toggleJobProfilePublishedStateRaw(requestParameters: ToggleJobProfilePublishedStateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PublishedResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/umbraco/api/MemberApi/ToggleJobProfilePublishedState`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ToggleProfilePublicStateToJSON(requestParameters.toggleProfilePublicState),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PublishedResponseFromJSON(jsonValue));
    }

    /**
     */
    async toggleJobProfilePublishedState(requestParameters: ToggleJobProfilePublishedStateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PublishedResponse> {
        const response = await this.toggleJobProfilePublishedStateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async toggleNetworkProfilePublishedStateRaw(requestParameters: ToggleNetworkProfilePublishedStateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PublishedResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/umbraco/api/MemberApi/ToggleNetworkProfilePublishedState`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ToggleProfilePublicStateToJSON(requestParameters.toggleProfilePublicState),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PublishedResponseFromJSON(jsonValue));
    }

    /**
     */
    async toggleNetworkProfilePublishedState(requestParameters: ToggleNetworkProfilePublishedStateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PublishedResponse> {
        const response = await this.toggleNetworkProfilePublishedStateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async unpublishProfilesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/MemberApi/UnpublishProfiles`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async unpublishProfiles(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.unpublishProfilesRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async updateAllowTrackingRaw(requestParameters: UpdateAllowTrackingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MessageResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/umbraco/api/MemberApi/UpdateAllowTracking`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AllowTrackingRequestToJSON(requestParameters.allowTrackingRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MessageResponseFromJSON(jsonValue));
    }

    /**
     */
    async updateAllowTracking(requestParameters: UpdateAllowTrackingRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MessageResponse> {
        const response = await this.updateAllowTrackingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateHideDownloadPopupRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MessageResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/MemberApi/UpdateHideDownloadPopup`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MessageResponseFromJSON(jsonValue));
    }

    /**
     */
    async updateHideDownloadPopup(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MessageResponse> {
        const response = await this.updateHideDownloadPopupRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async updateJobSearchDataRaw(requestParameters: UpdateJobSearchDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<JobSearchData>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/umbraco/api/MemberApi/UpdateJobSearchData`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: JobSearchDataToJSON(requestParameters.jobSearchData),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => JobSearchDataFromJSON(jsonValue));
    }

    /**
     */
    async updateJobSearchData(requestParameters: UpdateJobSearchDataRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<JobSearchData> {
        const response = await this.updateJobSearchDataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateLinkedinLearningAccountRaw(requestParameters: UpdateLinkedinLearningAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StatusResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/umbraco/api/MemberApi/UpdateLinkedinLearningAccount`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: LinkedinLearningAccountToJSON(requestParameters.linkedinLearningAccount),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StatusResponseFromJSON(jsonValue));
    }

    /**
     */
    async updateLinkedinLearningAccount(requestParameters: UpdateLinkedinLearningAccountRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StatusResponse> {
        const response = await this.updateLinkedinLearningAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateMemberRaw(requestParameters: UpdateMemberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateMemberResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/umbraco/api/MemberApi/UpdateMember`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CandidateMemberToJSON(requestParameters.candidateMember),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateMemberResponseFromJSON(jsonValue));
    }

    /**
     */
    async updateMember(requestParameters: UpdateMemberRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateMemberResponse> {
        const response = await this.updateMemberRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateProfileRaw(requestParameters: UpdateProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateProfileResponse>> {
        const queryParameters: any = {};

        if (requestParameters.onlyPersonalData !== undefined) {
            queryParameters['onlyPersonalData'] = requestParameters.onlyPersonalData;
        }

        if (requestParameters.profileSection !== undefined) {
            queryParameters['profileSection'] = requestParameters.profileSection;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/umbraco/api/MemberApi/UpdateProfile`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CandidateProfileToJSON(requestParameters.candidateProfile),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateProfileResponseFromJSON(jsonValue));
    }

    /**
     */
    async updateProfile(requestParameters: UpdateProfileRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateProfileResponse> {
        const response = await this.updateProfileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async uploadProfileImageRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/MemberApi/UploadProfileImage`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async uploadProfileImage(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.uploadProfileImageRaw(initOverrides);
        return await response.value();
    }

}
